module.exports = __webpack_public_path__ + "static/media/LogicWheel5_1_3.c7c67dad.png";